(()=>{"use strict";
const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
const setHeaderOffset=()=>{
  const h=document.querySelector(".torrex-site-header");
  if(!h)return;
  document.documentElement.style.setProperty("--torrex-header-offset",Math.ceil(h.getBoundingClientRect().height)+"px");
};
const initHeader=()=>{
  const h=document.querySelector(".torrex-site-header");
  if(!h)return;
  const onScroll=()=>h.classList.toggle("is-scrolled",window.scrollY>12);
  onScroll(); window.addEventListener("scroll",onScroll,{passive:true});
  setHeaderOffset(); window.addEventListener("resize",setHeaderOffset,{passive:true});
};
const initProduct=()=>{
  const shell=document.querySelector("[data-torrex-product]");
  if(!shell||window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;
  const stage=shell.querySelector("[data-torrex-product-stage]");
  const info=shell.querySelector("[data-torrex-product-info]");
  if(!stage||!info)return;
  const foldItems=[...info.children].filter(el=>el.nodeType===1);
  let raf=0;
  const update=()=>{
    raf=0;
    const rect=shell.getBoundingClientRect();
    const travel=Math.max(1,shell.offsetHeight-window.innerHeight);
    const progress=clamp((-rect.top)/travel,0,1);
    const wave=Math.sin(progress*Math.PI);
    stage.style.setProperty("--torrex-rx",((progress-.5)*2.2).toFixed(2)+"deg");
    stage.style.setProperty("--torrex-ry",((.5-progress)*3.2).toFixed(2)+"deg");
    stage.style.setProperty("--torrex-scale",(1+wave*.012).toFixed(4));
    const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--torrex-header-offset"))||76;
    const threshold=header+20;
    foldItems.forEach(el=>{
      const r=el.getBoundingClientRect();
      const fold=clamp((threshold-r.top)/145,0,1);
      el.style.setProperty("--torrex-fold",fold.toFixed(3));
    });
  };
  const request=()=>{if(!raf)raf=requestAnimationFrame(update)};
  update(); window.addEventListener("scroll",request,{passive:true}); window.addEventListener("resize",request,{passive:true});
};
const initStickyBuy=()=>{
  const shell=document.querySelector("[data-torrex-product]");
  const sticky=document.querySelector("[data-torrex-sticky-buy]");
  if(!shell||!sticky)return;
  const mainButton=shell.querySelector('[type="submit"][name="add"]');
  const stickyButton=sticky.querySelector("[data-torrex-sticky-button]");
  const stickyLabel=sticky.querySelector("[data-torrex-sticky-label]");
  const stickyPrice=sticky.querySelector("[data-torrex-sticky-price]");
  const price=shell.querySelector('[class*="__price"]');
  if(!mainButton||!stickyButton)return;

  let mainVisible=true;
  const sync=()=>{
    const disabled=mainButton.disabled||mainButton.getAttribute("aria-disabled")==="true";
    stickyButton.disabled=disabled;
    stickyButton.setAttribute("aria-disabled",disabled?"true":"false");
    const label=mainButton.querySelector('[data-torrex-atc-main]');
    if(stickyLabel&&label){
      const sub=mainButton.querySelector('[data-torrex-atc-sub]');
      stickyLabel.textContent=label.textContent.trim()+(sub&&!sub.hidden&&sub.textContent.trim()? " · "+sub.textContent.trim():"");
    }
    if(stickyPrice&&price)stickyPrice.textContent=price.textContent.trim();
  };
  const updateVisibility=()=>{
    const shouldShow=window.scrollY>180&&!mainVisible;
    sticky.classList.toggle("is-visible",shouldShow);
    sticky.setAttribute("aria-hidden",shouldShow?"false":"true");
  };

  const io=new IntersectionObserver(entries=>{
    mainVisible=entries[0]?.isIntersecting??true;
    updateVisibility();
  },{threshold:.15});
  io.observe(mainButton);

  const mo=new MutationObserver(sync);
  mo.observe(mainButton,{attributes:true,subtree:true,childList:true,characterData:true});
  const variant=shell.querySelector('select[name="id"]');
  if(variant)variant.addEventListener("change",()=>requestAnimationFrame(sync));
  window.addEventListener("scroll",updateVisibility,{passive:true});

  stickyButton.addEventListener("click",()=>{
    sync();
    if(stickyButton.disabled)return;
    mainButton.click();
  });
  sync();updateVisibility();
};
const initDirectBuy=()=>{
  document.querySelectorAll("[data-torrex-direct-buy]").forEach(wrapper=>{
    const form=wrapper.querySelector("form");
    const button=wrapper.querySelector('[type="submit"][name="add"]');
    if(!form||!button||form.dataset.torrexDirectBound==="true")return;
    form.dataset.torrexDirectBound="true";
    form.addEventListener("submit",async event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      if(button.disabled||button.getAttribute("aria-disabled")==="true")return;
      const spinner=button.querySelector(".loading__spinner");
      const error=wrapper.querySelector(".product-form__error-message-wrapper");
      const errorText=wrapper.querySelector(".product-form__error-message");
      button.setAttribute("aria-disabled","true");
      button.classList.add("loading");
      if(spinner)spinner.classList.remove("hidden");
      if(error)error.hidden=true;
      try{
        const formData=new FormData(form);
        const mainId=Number(formData.get("id"));
        const quantity=Math.max(1,Number(formData.get("quantity")||1));
        if(!mainId)throw new Error("Please select the watch option first");

        const mainItem={id:mainId,quantity};
        const giftIds=[...new Set(
          [...wrapper.querySelectorAll("[data-torrex-gift-variant]")]
            .map(el=>Number(el.dataset.torrexGiftVariant))
            .filter(Boolean)
        )];

        const cartResponse=await fetch((window.routes&&window.routes.cart_url)||"/cart.js",{headers:{"Accept":"application/json"}});
        const currentCart=await cartResponse.json();
        const existingGiftIds=new Set(
          (currentCart.items||[])
            .filter(item=>item.properties&&String(item.properties._torrex_free_gift)==="true")
            .map(item=>Number(item.variant_id||item.id))
        );

        const items=[mainItem];
        giftIds.forEach(id=>{
          if(!existingGiftIds.has(id)){
            items.push({
              id,
              quantity:1,
              properties:{
                _torrex_free_gift:"true",
                _torrex_parent_variant:String(mainId)
              }
            });
          }
        });

        const response=await fetch((window.routes&&window.routes.cart_add_url)||"/cart/add.js",{
          method:"POST",
          headers:{
            "X-Requested-With":"XMLHttpRequest",
            "Accept":"application/json",
            "Content-Type":"application/json"
          },
          body:JSON.stringify({items})
        });
        const data=await response.json();
        if(!response.ok||data.status)throw new Error(data.description||data.message||"Unable to add product");
        window.location.assign("/checkout");
      }catch(err){
        if(errorText)errorText.textContent=err.message||"Unable to continue to checkout";
        if(error)error.hidden=false;
        button.removeAttribute("aria-disabled");
        button.classList.remove("loading");
        if(spinner)spinner.classList.add("hidden");
      }
    },true);
  });
};
const initLooxReviewJump=()=>{
  document.querySelectorAll("[data-torrex-loox-jump]").forEach(link=>{
    link.addEventListener("click",event=>{
      const target=document.querySelector("#looxReviews, .loox-reviews-default, .loox-reviews, [data-loox-aggregate]");
      if(!target)return;
      event.preventDefault();
      target.scrollIntoView({behavior:"smooth",block:"start"});
      try{history.replaceState(null,"","#looxReviews")}catch(e){}
    });
  });
};
const boot=()=>{initHeader();initProduct();initStickyBuy();initDirectBuy();initLooxReviewJump()};
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot,{once:true});else boot();
})();

/* TORREX_GIFT_CART_GUARD
 * Gift variants are addable only as complimentary T-R1 lines.
 * This guard removes standalone/duplicate gift lines and forces one of each gift.
 */
(()=>{
  const WATCH_VARIANT_ID=60219571503185;
  const GIFT_VARIANT_IDS=new Set([63352715214929,63353069437009]);
  let running=false;

  async function sanitizeTorrexGiftCart(){
    if(running)return;
    running=true;
    try{
      const response=await fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
      if(!response.ok)return;
      const cart=await response.json();
      if(!cart||!Array.isArray(cart.items))return;

      const hasWatch=cart.items.some(item=>Number(item.variant_id||item.id)===WATCH_VARIANT_ID);
      const seen=new Set();
      const updates={};

      cart.items.forEach(item=>{
        const variantId=Number(item.variant_id||item.id);
        if(!GIFT_VARIANT_IDS.has(variantId))return;

        if(!hasWatch){
          updates[item.key]=0;
          return;
        }

        if(seen.has(variantId)){
          updates[item.key]=0;
          return;
        }

        seen.add(variantId);
        if(Number(item.quantity)!==1){
          updates[item.key]=1;
        }
      });

      if(!Object.keys(updates).length)return;

      const updateResponse=await fetch('/cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({updates})
      });

      if(updateResponse.ok){
        window.location.reload();
      }
    }catch(error){
      console.warn('Torrex gift cart guard:',error);
    }finally{
      running=false;
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',sanitizeTorrexGiftCart,{once:true});
  }else{
    sanitizeTorrexGiftCart();
  }
})();
